/**
 *Created by jmmartinez on 3/8/18
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  02/02/2021 Añadida función transformarDatosLista
 **/

import React from 'react'
import { Pie, ResponsivePie } from '@nivo/pie'
import PropTypes from 'prop-types';
import {floatToFloat2Decimales, stringComasToFloat} from '../ej2/utils/NumberUtils'



class TartaResponsive extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datos: props.datos,
            campoNombre: props.campoNombre,
            campoValor: props.campoValor,
            mostrarLeyenda: props.mostrarLeyenda ? props.mostrarLeyenda : false,
            umbralVarios: props.umbralVarios ? props.umbralVarios : 5.0,
        }
        console.log("TARTA - Constructor");
    }



    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.datos !== prevState.datos) {
            newState.datos = nextProps.datos;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    transformarDatos= () => {
        const {datos, campoNombre, campoValor, umbralVarios} = this.state;
        //console.log("Transformar Datos");
        //console.log(campoNombre.toUpperCase());
        let acumuladoUmbral= 0;
        if (datos && datos.rows) {
            let datosGrafica = datos.rows.reduce((datosReduced, row) => {
                if (!row.esPie) {
                    let valor=  stringComasToFloat(row.propiedades[campoValor.toUpperCase()]);
                    if (valor < umbralVarios){
                        acumuladoUmbral += valor;
                    }
                    else {
                        let elemento = {
                            id: row.propiedades[campoNombre.toUpperCase()],
                            label: row.propiedades[campoNombre.toUpperCase()],
                            value: valor,
                        }
                        datosReduced.push(elemento);
                    }
                }
                return datosReduced;
            }, []);
            if (acumuladoUmbral > 0){
                let elemento = {
                    id: "Otros",
                    label: "Otros",
                    value: floatToFloat2Decimales(acumuladoUmbral),
                }
                datosGrafica.push(elemento);
            }
            return datosGrafica;
        }
        else{
            return [];
        }
    }

    transformarDatosLista= () => {
        const {datos, campoNombre, campoValor, umbralVarios} = this.state;
        //console.log("Transformar Datos");
        let acumuladoUmbral= 0;
        if (datos) {
            let datosGrafica = datos.reduce((datosReduced, row) => {
                let valor=  row[campoValor];
                if (valor < umbralVarios){
                    acumuladoUmbral += valor;
                }
                else {
                    let elemento = {
                        id: row[campoNombre],
                        label: row[campoNombre],
                        value: valor,
                    }
                    datosReduced.push(elemento);
                }
                return datosReduced;
            }, []);

            if (acumuladoUmbral > 0){
                let elemento = {
                    id: "Otros",
                    label: "Otros",
                    value: floatToFloat2Decimales(acumuladoUmbral),
                }
                datosGrafica.push(elemento);
            }

            console.log("Datos grafica: ");
            console.log(datosGrafica);
            return datosGrafica;
        }
        else{
            return [];
        }
    }

    render() {
        const {datos, mostrarLeyenda} =  this.state;

        let legends = [
                {
                    "anchor": "bottom",
                    "direction": "row",
                    "translateY": 56,
                    "itemWidth": 100,
                    "itemHeight": 18,
                    "symbolSize": 18,
                    "symbolShape": "circle"
                }];
        if (!mostrarLeyenda)
            legends = [];


        return (
            <ResponsivePie
                data={this.transformarDatosLista()}
                margin={{
                    "top": 40,
                    "right": 80,
                    "bottom": 80,
                    "left": 80
                }}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                colors={{scheme: 'nivo'}}
                colorBy="id"
                borderWidth={1}
                borderColor="inherit:darker(0.2)"
                radialLabelsSkipAngle={10}
                radialLabelsTextXOffset={6}
                radialLabelsTextColor="#333333"
                radialLabelsLinkOffset={0}
                radialLabelsLinkDiagonalLength={16}
                radialLabelsLinkHorizontalLength={24}
                radialLabelsLinkStrokeWidth={1}
                //radialLabelsLinkColor="inherit"
                slicesLabelsSkipAngle={10}
                slicesLabelsTextColor="#333333"
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                theme={{
                    "tooltip": {
                        "container": {
                            "fontSize": "13px"
                        }
                    },
                    "labels": {
                        "textColor": "#555"
                    }
                }}
                legends={legends}
                sortByValue={true}
            />
        );
    }
}


TartaResponsive.propTypes = {
    datos: PropTypes.array,
    campoNombre: PropTypes.string,
    campoValor: PropTypes.string,
    mostrarLeyenda: PropTypes.bool,
    umbralVarios: PropTypes.number,
}

export default TartaResponsive

